import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import xinanprivacyClause from '@/components/xinanprivacyClause'
import xinanuserAgreement from '@/components/xinanuserAgreement'
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'Login',
            component: Login,
            meta: 10
        },
        {
            path: '/xinanprivacyClause',
            name: 'xinanprivacyClause',
            component: xinanprivacyClause,
            meta: {
                title: "杺桉物联隐私协议",
                content: 'disable'
            }
        },
        {
            path: '/xinanuserAgreement',
            name: 'xinanuserAgreement',
            component: xinanuserAgreement,
            meta: {
                title: "杺桉物联用户协议",
                content: 'disable'
            }
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js